import Vue from 'vue';
import mandateProvider from '@/apiProviders/mandates/mandate.provider';
import Pagination from '@/viewModels/Pagination.class';
import OrderDirection from '@/consts/orderDirection.enum';

const mandateListModule = {
  namespaced: true,

  state: {
    mandatesList: [],
    mandatesListPagination: new Pagination(1, 50, 0, 'JobId', OrderDirection.DESC),
    mandatesListFilters: {
      textSearch: '',
      mine: false,
      active: false,
    },
  },

  actions: {
    async fetchMandatesList({ commit, state, rootGetters }) {
      const mandatesFilters = {
        textSearch: state.mandatesListFilters.textSearch,
        user: state.mandatesListFilters.mine ? rootGetters['authModule/UserName'] : undefined,
        jobStatus: state.mandatesListFilters.active ? '0,1,2,4,5' : undefined,
      };

      const { rows: mandatesList, nSkip, nTake, page } = await mandateProvider.advancedSearchJob({ ...state.mandatesListPagination.pagination, ...state.mandatesListPagination.sorting, ...mandatesFilters });
      state.mandatesListPagination.pagination = { page, nTake, nSkip };

      commit('setMandatesList', mandatesList);
    },

    setMandatesListFilters({ commit }, filters) {
      commit('setMandatesListFilters', filters);
    },
  },

  mutations: {
    setMandatesList(state, payload) {
      Vue.set(state, 'mandatesList', payload);
    },
    setMandatesListFilters(state, payload) {
      Vue.set(state, 'mandatesListFilters', payload);
    },
  },

  getters: {},
};

export default mandateListModule;
